import { render, staticRenderFns } from "./CommonManufacturerModal.vue?vue&type=template&id=4e4959ce&"
import script from "./CommonManufacturerModal.vue?vue&type=script&lang=js&"
export * from "./CommonManufacturerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports